module.exports = __webpack_public_path__ + "img/wechat.aa7f255.png";